import { render, staticRenderFns } from "./GoodsCategorySelect.vue?vue&type=template&id=7583c1cb&scoped=true&"
import script from "./GoodsCategorySelect.vue?vue&type=script&lang=js&"
export * from "./GoodsCategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCategorySelect.vue?vue&type=style&index=0&id=7583c1cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7583c1cb",
  null
  
)

export default component.exports